import { configureStore } from '@reduxjs/toolkit';
import loader from './loading.slice';
import partiallyLoader from './partiallyLoading.slice';
import lang from './lang.slice';
import isFullFooter from './isFullFooter.slice';
import pageState from './pageState.slice';
import tenant from './tenant.slice';
import enumsSlice from './enums.slice';
import appointmentData from './appointmentData.slice';
import clientSlug from './clientSlug.slice';
import settings from './settings.slice';
import clientData from './clientData.slice';
import teamSlug from './teamSlug.slice';
import tenantSlug from './tenantSlug.slice';
import eventData from './eventData.slice';

export const store = configureStore({
  reducer: {
    loader,
    partiallyLoader,
    lang,
    isFullFooter,
    pageState,
    tenant,
    enumsSlice,
    appointmentData,
    clientSlug,
    settings,
    clientData,
    teamSlug,
    tenantSlug,
    eventData
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
